<template>
  <div>

    <div class="col-md-6 col-12" v-if='logged'>
      <chart-card v-if='chartData.data !== undefined' subTitle='Membros que mais pegam livros' title="Top 9 Leitores" :chart-data="chartData.data">
        <div slot='footer' class="custom-control custom-checkbox">
          <input type="checkbox"  id="customCheck" class="custom-control-input" v-model='chartData.children' @change='initLeitoresChart()'>
          <label class="custom-control-label" for="customCheck">Incluir Livros Infantis</label>
        </div>
      </chart-card>
    </div>
    <div class="col-md-6 col-12">
      <chart-card v-if='booksData.data !== undefined' subTitle='Livros mais procurados' title="Top 9 Livros" :chart-data="booksData.data">
        <div slot='footer' class="custom-control custom-checkbox">
          <input type="checkbox" id="customCheck2" class="custom-control-input" v-model='booksData.children' @change='initBooksChart()'>
          <label class="custom-control-label" for="customCheck2">Incluir Livros Infantis</label>
        </div>
      </chart-card>
    </div>
    <div class="col-md-6 col-12">
      <chart-card v-if='booksEditoraData.data !== undefined' subTitle='Quantidade de livros por editora' title="Livros Por Editora" :chart-data="booksEditoraData.data">
      </chart-card>
    </div>
    <div class="col-md-6 col-12">
      <chart-card v-if='autoresData.data !== undefined' subTitle='Autores mais procurados para empréstimos' title="Autores mais procurados" :chart-data="autoresData.data">
      </chart-card>
    </div>
    <div class="col-md-6 col-12">
      <chart-card v-if='categoriasData.data !== undefined' subTitle='Categorias mais procuradas para empréstimos' title="Categorias mais procuradas" :chart-data="categoriasData.data">
      </chart-card>
    </div>
    <div class="col-md-6 col-12">
      <chart-card v-if='emprestimosPorMes.data !== undefined' :options='emprestimosPorMes.options' title="Empréstimos Por Mês" :chart-data="emprestimosPorMes.data" type='line'>
      </chart-card>
    </div>
    <div class="col-md-6 col-12">
      <chart-card v-if='obrasPorMes.data !== undefined' :options='obrasPorMes.options' title="Obras Adicionadas Por Mês" :chart-data="obrasPorMes.data" type='line'>
      </chart-card>
    </div>
    <div class="col-md-6 col-12">
      <chart-card v-if='emprestimosMediaSemanas.data !== undefined' :options='emprestimosMediaSemanas.options' title="Média de Semanas por Renovação" type='bubble' :chart-data="emprestimosMediaSemanas.data">
        <div slot='footer' class="custom-control custom-checkbox">
          <input type="checkbox" id="customCheck3" class="custom-control-input" v-model='emprestimosMediaSemanas.children' @change='initEmprestimosMediaSemanas()'>
          <label class="custom-control-label" for="customCheck3">Incluir Livros Infantis</label>
        </div>
      </chart-card>
    </div>
    <table-emprestimos-semanas @change='initEmprestimos($event)' v-if='emprestimos.data' :emprestimos='emprestimos' title="Empréstimos de Maior Duração"></table-emprestimos-semanas>

  </div>
</template>
<script>
import { ChartCard } from '@/components/index'
import AuthService from '../services/auth-service'
import EmprestimoService from '../services/emprestimo-service'
import ObraService from '../services/obra-service'
import OverlayService from '../services/overlay-service'
import TableEmprestimosSemanas from '../components/TableEmprestimosSemanas'

export default {
  components: {
    ChartCard,
    TableEmprestimosSemanas
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  data () {
    return {
      logged: false,
      maxLabelLength: 40,
      chartData: { children: false, data: undefined },
      booksData: { children: false, data: undefined },
      booksEditoraData: { data: undefined },
      autoresData: { data: undefined },
      categoriasData: { data: undefined },
      emprestimos: { children: false, data: undefined },
      emprestimosPorMes: {
        data: undefined,
        options: { legend: { display: false }}
      },
      obrasPorMes: { data: undefined, options: { legend: { display: false }}},
      emprestimosMediaSemanas: {
        children: false,
        data: undefined,
        options: {
          legend: {
            display: false
          },
          scales: {
            yAxes: [
              {
                scaleLabel: {
                  display: true,
                  labelString: 'Renovações'
                }
              }
            ],
            xAxes: [
              {
                scaleLabel: {
                  display: true,
                  labelString: 'Semanas por Renovação'
                }
              }
            ]
          }
        }
      },
      colors: [
        '#e51c23',
        '#e91e63',
        '#9c27b0',
        '#673ab7',
        '#3f51b5',
        '#5677fc',
        '#03a9f4',
        '#00bcd4',
        '#009688',
        '#259b24',
        '#8bc34a',
        '#cddc39',
        '#ffeb3b',
        '#ffc107',
        '#ff9800',
        '#ff5722',
        '#795548',
        '#9e9e9e',
        '#607d8b',
        '#F7464A'
      ]
    }
  },

  methods: {
    getRandomColor () {
      const letters = '0123456789ABCDEF'
      let color = '#'
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    },

    initEmprestimos (filter = { limit: 10 }) {
      OverlayService.trigger('show', true)
      EmprestimoService.getTopEmprestimos(this.emprestimos.children, filter)
        .then(response => response.data)
        .then(data => {
          OverlayService.trigger('show', false)
          this.emprestimos.data = data
        })
        .catch(er => OverlayService.trigger('show', false))
    },

    initEmprestimosMediaSemanas () {
      this.emprestimosMediaSemanas.data = undefined
      EmprestimoService.getTopMediaEmprestimosSemanas(
        this.emprestimosMediaSemanas.children
      )
        .then(response => response.data)
        .then(data => {
          this.emprestimosMediaSemanas.data = {
            labels: 'Coisa',
            datasets: data.map((d, index) => {
              const color = this.getRandomColor()

              return {
                label: [`${d.nome} ${d.sobrenome}`],
                backgroundColor: color,
                borderColor: color,
                data: [
                  {
                    r: d.quantidade_emprestimos,
                    y: d.media_renovacoes,
                    x: d.media_semanas_por_renovacao
                  }
                ]
              }
            })
          }
        })
    },

    initLeitoresChart () {
      this.chartData.data = undefined
      EmprestimoService.getTopLeitores(this.chartData.children)
        .then(response => {
          return response.data
        })
        .then(data => {
          this.chartData.data = {
            labels: data.map(membro => `${membro.nome} ${membro.sobrenome}`),
            datasets: []
          }

          const dataset = {
            backgroundColor: this.colors,
            data: data.map(membro => membro.count)
          }
          this.chartData.data.datasets.push(dataset)
        })
    },

    initAutoresChart () {
      this.autoresData.data = undefined
      EmprestimoService.getTopAutores(this.autoresData.children)
        .then(response => {
          return response.data
        })
        .then(data => {
          this.autoresData.data = {
            labels: data.map(membro => membro.nome_autor),
            datasets: []
          }

          const dataset = {
            backgroundColor: this.colors,
            data: data.map(membro => membro.count)
          }
          this.autoresData.data.datasets.push(dataset)
        })
    },

    initCategoriasChart () {
      this.categoriasData.data = undefined
      EmprestimoService.getTopCategorias(this.categoriasData.children)
        .then(response => {
          return response.data
        })
        .then(data => {
          this.categoriasData.data = {
            labels: data.map(membro => membro.nome_categoria),
            datasets: []
          }

          const dataset = {
            backgroundColor: this.colors,
            data: data.map(membro => membro.count)
          }
          this.categoriasData.data.datasets.push(dataset)
        })
    },

    initEmprestimosPorMesChart () {
      this.emprestimosPorMes.data = undefined
      EmprestimoService.getEmprestadosPorMes()
        .then(response => response.data)
        .then(data => {
          this.emprestimosPorMes.data = {
            labels: data.map(
              membro => `${this.leftZero(membro.month)}/${membro.year}`
            ),
            datasets: []
          }

          const dataset = {
            fill: false,
            borderColor: '#3cba9f',
            data: data.map(membro => membro.count)
          }
          this.emprestimosPorMes.data.datasets.push(dataset)
        })
    },

    initObrasPorMesChart () {
      this.obrasPorMes.data = undefined
      ObraService.getObrasPorMes()
        .then(response => response.data)
        .then(data => {
          this.obrasPorMes.data = {
            labels: data.map(
              membro => `${this.leftZero(membro.month)}/${membro.year}`
            ),
            datasets: []
          }

          const dataset = {
            fill: false,
            borderColor: '#8e5ea2',
            data: data.map(membro => membro.count)
          }
          this.obrasPorMes.data.datasets.push(dataset)
        })
    },

    initLivrosPorEditora () {
      this.booksEditoraData.data = undefined
      ObraService.getObrasPorEditora(9)
        .then(response => response.data)
        .then(data => {
          this.booksEditoraData.data = {
            labels: data.map(membro => membro.nome_editora),
            datasets: []
          }

          const dataset = {
            backgroundColor: this.colors,
            data: data.map(membro => membro.count)
          }
          this.booksEditoraData.data.datasets.push(dataset)
        })
    },

    leftZero (value) {
      if (value < 10) {
        return `0${value}`
      }
      return value
    },

    initBooksChart () {
      this.booksData.data = undefined

      EmprestimoService.getTopBook(this.booksData.children)
        .then(response => response.data)
        .then(data => {
          this.booksData.data = {
            labels: data.map(
              obra =>
                obra.titulo.length > this.maxLabelLength
                  ? `${obra.titulo.substring(0, this.maxLabelLength)}...`
                  : obra.titulo
            ),
            datasets: []
          }

          const dataset = {
            backgroundColor: this.colors,
            data: data.map(obra => obra.count)
          }
          this.booksData.data.datasets.push(dataset)
        })
    }
  },

  mounted () {
    this.logged = AuthService.isLogged()
    if (this.logged) {
      this.initLeitoresChart()
      this.initEmprestimos()
      this.initEmprestimosMediaSemanas()
    }
    this.initAutoresChart()
    this.initObrasPorMesChart()
    this.initEmprestimosPorMesChart()
    this.initBooksChart()
    this.initLivrosPorEditora()
    this.initCategoriasChart()
  }
}
</script>
<style scoped>
.custom-checkbox > * {
  display: inline;
}
</style>
